
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import ClusterForm from '../components/forms/ClusterForm';
import '../styles/EmployeeMaster.css';
import ClusterTable from '../components/ClusterTable';

const ClusterModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/cluster/add';

  const handleAddClick = () => {
    navigate('/cluster/add');
  };

  const handleCloseModal = () => {
    navigate('/cluster');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Cluster Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Cluster
        </button>
      </div>

      <ClusterTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Cluster</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ClusterForm />
        </Modal.Body>
        
      </Modal>
    </div>
  );
};

export default ClusterModel;
